import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DataTableModule } from '../../data-table/data-table.module';
import { DataWidgetsModule } from '../rankings/data-widgets/data-widgets.module';
import { DetailsPageModule } from '../insights/details-page/details-page.module';
import { DirectivesModule } from 'app/directives/directives.module';
import { PipesModule } from '../../../pipes/pipes.module';
import { SharedModule } from '../../shared/shared.module';
import { TooltipModule } from '../../tooltip/tooltip.module';

import { SdkIdentityComponent } from './side-insight/sdk-identity/sdk-identity.component';
import { SdkIndexComponent } from './sdk-index.component';
import { SdkRouting, SdkRoutingProviders } from './sdk-index.routing';
import { SideInsightComponent } from './side-insight/side-insight.component';
import { SdkOverviewRisksV2Component } from './side-insight/sdk-overview-risks-v2/sdk-overview-risks-v2.component';
import { SdkPrivacyDisclosureComponent } from './side-insight/sdk-privacy-disclosure/sdk-privacy-disclosure.component';

@NgModule({
  declarations: [
    SdkIdentityComponent,
    SdkOverviewRisksV2Component,
    SdkPrivacyDisclosureComponent,
    SdkIndexComponent,
    SideInsightComponent
  ],
  imports: [
    CommonModule,
    DataTableModule,
    DataWidgetsModule,
    DetailsPageModule,
    DirectivesModule,
    FormsModule,
    PipesModule,
    SharedModule,
    TooltipModule,

    SdkRouting
  ],
  exports: [],
  providers: [SdkRoutingProviders]
})
export class SdkIndexModule {}
